(() => {
  if (customElements.get('trusted-shops-summary')) return;

  // Share one request across section instances, including theme editor reloads.
  let feedRequest;
  const loadFeed = (url) => {
    if (!feedRequest) {
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 5000);
      feedRequest = fetch(url, { cache: 'no-cache', credentials: 'omit', signal: controller.signal })
        .then((response) => {
          if (!response.ok) throw new Error('Unable to load Trusted Shops ratings');
          return response.json();
        })
        .catch((error) => {
          feedRequest = null;
          throw error;
        })
        .finally(() => window.clearTimeout(timeout));
    }
    return feedRequest;
  };

  customElements.define('trusted-shops-summary', class extends HTMLElement {
    async connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      const ratingElement = this.querySelector('[data-summary-rating]');
      const scoreElement = this.querySelector('[data-summary-score]');
      const countElement = this.querySelector('[data-summary-count]');
      this.setAttribute('aria-busy', 'true');
      countElement.textContent = 'Bewertungen werden geladen …';

      try {
        const data = await loadFeed(this.dataset.feedUrl);
        // Match the product page: trailing-year score, lifetime review count.
        const score = data?.grades?.['365days']?.rating;
        const count = data?.grades?.overall?.count;
        if (!Number.isFinite(score) || score < 0 || score > 5 || !Number.isSafeInteger(count) || count < 0) {
          throw new Error('Invalid Trusted Shops rating data');
        }

        if (score === 0 || count === 0) {
          countElement.textContent = 'Noch keine Bewertung für die letzten 12 Monate verfügbar.';
          ratingElement.setAttribute('aria-label', 'Keine aktuelle Bewertung verfügbar');
          return;
        }

        const formattedScore = new Intl.NumberFormat('de-DE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(score);
        const formattedCount = new Intl.NumberFormat('de-DE').format(count);

        scoreElement.textContent = formattedScore;
        countElement.textContent = `bei ${formattedCount} Bewertungen insgesamt.`;
        ratingElement.setAttribute('aria-label', `${formattedScore} von 5 Sternen in den letzten 12 Monaten`);
        this.querySelectorAll('[data-summary-star]').forEach((star, index) => {
          star.style.width = `${Math.max(0, Math.min(1, score - index)) * 100}%`;
        });
      } catch {
        countElement.textContent = 'Aktuelle Bewertung auf Trusted Shops ansehen.';
        ratingElement.setAttribute('aria-label', 'Bewertung derzeit nicht verfügbar');
      } finally {
        this.setAttribute('aria-busy', 'false');
      }
    }
  });
})();
